<form [formGroup]="borrowerDetails" id="borrower-details" (ngSubmit)=onSubmit(borrowerDetails)>
	<div class="d-flex flex-column justify-content-lg-start  justify-content-sm-center text-right m-step-wrapper1 container" [ngClass]="{'first-question' : !prevQID}" style="	max-width: 1280px;">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" (editQuestionChange)="editQuestionChange($event)">
			<!-- question 1 -->
			<question [qID]="'1'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION1.QUESTION"|translate}}</h1>

					<div class="row  form-row justify-content-md-start justify-content-center">
						<div class="form-group col-12 col-md-4 col-md-4 input-wrapper pr-0 w-100 mt-3">  
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION1.CHILDREN_NUMBER"|translate}}</label>

							<app-dplist-new [valueArr]='childrenNumber' formControlName="childrenNumber" [disabled]="borrowerDetails.get('childrenNumber').disabled" [asyncData]="false" [atrrAriaLabel]="'BORROWERS_DETAILS.QUESTION1.CHILDREN_NUMBER'|translate"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('childrenNumber').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
						<div class="form-group col-12 col-md-4 col-md-4 input-wrapper pr-0 w-100 mt-3">  
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION1.PLACE_RESIDENCE"|translate}}</label>

							<app-dplist-new [valueArr]='placeResidence' formControlName="placeResidence" [disabled]="borrowerDetails.get('placeResidence').disabled" [asyncData]="false" [atrrAriaLabel]="'BORROWERS_DETAILS.QUESTION1.PLACE_RESIDENCE'|translate"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('placeResidence').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-md-5 mt-4">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='1', 'button-primary-disabled': !borrowerDetails.valid}">{{"BORROWERS_DETAILS.QUESTION1.BUTTON"|translate}}</button>

					</div>
				</div>
			</question>

			<!-- question 4.1 -->
			<question [qID]="'4.1'">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION4_1.QUESTION"|translate}}</h1>

		
						<div class="btn-group-toggle " data-toggle="buttons">
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('payMezonot').value==='YES'}" tabindex="0" data-id="qID4.1a" data-fieldName="payMezonot" data-fieldValue="YES">
								{{"COMMON.YES"|translate}}
								<input class="radio" type="radio" formControlName="payMezonot" value="YES" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
							</label>
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('payMezonot').value==='NO'}" tabindex="0" data-id="qID4.1b" data-fieldName="payMezonot" data-fieldValue="NO">
								{{"COMMON.NO"|translate}}
								<input class="radio" type="radio" formControlName="payMezonot" value="NO" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
							</label>
						</div>
						</div>
			</question>
				
			<!-- question 5 -->
			<question [qID]="'5'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION5.QUESTION"|translate}}</h1>

					<div class="row  form-row justify-content-md-start justify-content-center">
						<div class="form-group col-12 col-md-4 col-md-4 input-wrapper pr-0 w-100 mt-3">  
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"COMMON.SELECT_EDUCATION_PH"|translate}}</label>
	
							<app-dplist-new [valueArr]='educationCombo' formControlName="education" [disabled]="borrowerDetails.get('education').disabled" [asyncData]="false" [atrrAriaLabel]="'COMMON.SELECT_EDUCATION_PH'|translate"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('education').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						  </div>
						  <div class="form-group col-12 col-md-6 col-md-6 input-wrapper pr-0 w-100 mt-3">  
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION5.PH1"|translate}}</label>

						  <app-mat-autocomplete [data]="professionsList" formControlName="profession" placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH1'|translate}}"></app-mat-autocomplete>
						  <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('profession').hasError('required') && submitted" role="alert">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</label>
                         </div>
                </div>
					</div>

					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='5', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
			</question>

			<!-- question 7 -->
			<question [qID]="'7'">
				<h1>{{'BORROWERS_DETAILS.QUESTION7.QUESTION'|translate}}</h1>
				<div class="d-flex  justify-content-md-start justify-content-center text-center">
					<box-selector formControlName="employmentStatus" [options]="options" (optionClicked)="onSubmit(borrowerDetails)" [(selectedOption)]="selectedOption"></box-selector>

				</div>
			</question>

			<question [qID]="'7.1'">
				<label class="max-width-page" tabindex="0" data-id="qID7.1">
					<div class="text-lg-right text-md-center text-center">
						<h1 class="app-title-xxxlarge-blue">{{'BORROWERS_DETAILS.QUESTION7-1.QUESTION'|translate}}</h1>
					</div>
				</label>
		
				<div class="d-flex flex-column justify-content-md-start justify-content-center">
					<app-mat-autocomplete [data]="cities" formControlName="yeshuvAvodaForIndependent" placeholder="{{'BORROWERS_DETAILS.QUESTION7-1.PH1'|translate}}" [attAriaLabel]="'BORROWERS_DETAILS.QUESTION7-1.PH1'|translate"></app-mat-autocomplete>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('yeshuvAvodaForIndependent').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('yeshuvAvodaForIndependent').hasError('isNotInList') && !borrowerDetails.get('yeshuvAvodaForIndependent').hasError('required') && submitted">
						{{'BORROWERS_DETAILS.QUESTION7-1.NOT_IN_LIST_ERROR' | translate}}
					</label> 
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5 mt-md-0">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='7.1', 'button-primary-disabled': !(borrowerDetails.valid && qID=='7.1')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<!-- question 8 -->
			<question [qID]="'8a'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION8.QUESTION_A"|translate}}</h1>

	
					<div class="btn-group-toggle " data-toggle="buttons">
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-a').value==='under1'}" tabindex="0" data-id="qID8aa" data-fieldName="startOfWorkDateWithEmployer-a" data-fieldValue="under1">
							{{"BORROWERS_DETAILS.QUESTION8.OP1"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-a" value="under1" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-a').value==='over1'}" tabindex="0" data-id="qID8ab" data-fieldName="startOfWorkDateWithEmployer-a" data-fieldValue="over1">
							{{"BORROWERS_DETAILS.QUESTION8.OP2"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-a" value="over1" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-a').value==='over3'}" tabindex="0" data-id="qID8ac" data-fieldName="startOfWorkDateWithEmployer-a" data-fieldValue="over3">
							{{"BORROWERS_DETAILS.QUESTION8.OP3"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-a" value="over3" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
					</div>
					</div>
			</question>

			<question [qID]="'8b'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION8.QUESTION_B"|translate}}</h1>

	
					<div class="btn-group-toggle " data-toggle="buttons">
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-b').value==='under1'}" tabindex="0" data-id="qID8ba" data-fieldName="startOfWorkDateWithEmployer-b" data-fieldValue="under1">
							{{"BORROWERS_DETAILS.QUESTION8.OP1"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-b" value="under1" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-b').value==='over1'}" tabindex="0" data-id="qID8bb" data-fieldName="startOfWorkDateWithEmployer-b" data-fieldValue="over1">
							{{"BORROWERS_DETAILS.QUESTION8.OP2"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-b" value="over1" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-b').value==='over3'}" tabindex="0" data-id="qID8bc" data-fieldName="startOfWorkDateWithEmployer-b" data-fieldValue="over3">
							{{"BORROWERS_DETAILS.QUESTION8.OP3"|translate}}
							<input class="radio" type="radio" formControlName="startOfWorkDateWithEmployer-b" value="over3" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
					</div>
					</div>
			</question>

			<!-- question 9 -->
            <question [qID]="'9a'">
				<div class="mx-4 mt-md-0 mt-5">

					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION9.QUESTION"|translate}}</h1>
					<div class="row ">
						<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
						<div class="">
							<app-animated-input formControlName="howLongWorkedPreviousWorkplace-a" [minValue]="0" [type]="'number'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION9.QUESTIONa'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="false" [hasTitle]="false" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('howLongWorkedPreviousWorkplace-a').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('howLongWorkedPreviousWorkplace-a').hasError('negativeNumber') && !borrowerDetails.get('howLongWorkedPreviousWorkplace-a').hasError('required') && submitted" role="alert">{{ 'COMMON.NEGATIVE_NUMBER' | translate }}</label>
						</div>
					</div>
					</div>
	
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='9a', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
					</div>
            </question>

            <question [qID]="'9b'">
				<div class="mx-4 mt-md-0 mt-5">

					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION9.QUESTION"|translate}}</h1>
					<div class="row ">
						<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
						<div class="">
							<app-animated-input formControlName="howLongWorkedPreviousWorkplace-b" [minValue]="0" [type]="'number'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION9.QUESTIONb'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="false" [hasTitle]="false" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('howLongWorkedPreviousWorkplace-b').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('howLongWorkedPreviousWorkplace-b').hasError('negativeNumber') && !borrowerDetails.get('howLongWorkedPreviousWorkplace-b').hasError('required') && submitted" role="alert">{{ 'COMMON.NEGATIVE_NUMBER' | translate }}</label>
						</div>
					</div>
					</div>
	
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='9b', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
				</div>
            </question>

			<!-- question 10 -->
			<question [qID]="'10'">
				<div class="mx-4 mt-md-0 mt-5">

					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION10.QUESTION"|translate}}</h1>
					<div class="row ">
						<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
						<div class="">
							<app-animated-input formControlName="monthlyIncome" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION10.PH1' | translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION10.QUESTION'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [hasTitle]="false" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('monthlyIncome').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>
					</div>
	
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='10', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
				</div>
			</question>

			<!-- question 11 -->
			<question [qID]="'11'">
				<div class="mx-4 mt-md-0 mt-5">
				<div class="text-md-right text-center mb-3">
					<h1 class="app-title-xxxlarge-blue">
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION1"|translate}}</div>
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION2"|translate}}</div>
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION3"|translate}}</div>
					</h1>
				</div>
		
				<div class="row d-flex justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center">
					 <div class="col-12 col-lg-3 mt-2 mt-md-0">
						<app-animated-input formControlName="employersCompanyName" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION11.PH1' | translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION11.PH1'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="true" [hasTitle]="false" tabindex="0"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersCompanyName').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersCompanyName').hasError('pattern') && submitted" role="alert">{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
						
				     </div>
						<!--Company Classification-->
						<div class="col-12 col-lg-3 mt-md-n4 mt-0">
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH3"|translate}}</label>

							<app-dplist-new [valueArr]='companyClassificationList' formControlName="employersCompanyClassification" tabindex="0"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersCompanyClassification').hasError('required') && submitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>							
						</div>
				

						<div class="col-12 col-lg-3 mt-md-n4 mt-0">
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH4"|translate}}</label>
							<div class="input-wrapper">
								<app-mat-autocomplete [data]="cities" formControlName="employersYeshuvAvoda" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}" [attAriaLabel]="'PROPERTY_DETAILS.Q1.PH1'|translate"></app-mat-autocomplete>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersYeshuvAvoda').hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersYeshuvAvoda').hasError('isNotInList') && !borrowerDetails.get('employersYeshuvAvoda').hasError('required') && submitted">
									{{'PROPERTY_DETAILS.Q1.NOT_IN_LIST_ERROR' | translate}}
								</label> 
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid, 'button-primary-disabled': !(borrowerDetails.valid && qID=='11')}">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
					</div>
			</question>

			<!-- question 13 -->
			<question [qID]="'13'">
				<div class="mx-4 mt-md-0 mt-5">

					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION13.QUESTION"|translate}}</h1>
					<div class="row ">
						<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
						<div class="">
							<app-animated-input formControlName="annualIncome" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION13.PH1' | translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION13.QUESTION'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [hasTitle]="false" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-02" *ngIf="borrowerDetails.get('annualIncome').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>
					</div>
	
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='13', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
				</div>
			</question>

			<!-- question 14 -->
			<question [qID]="'14'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION14.QUESTION1"|translate}} {{"BORROWERS_DETAILS.QUESTION14.QUESTION2"|translate}}</h1>

					
				<div class="row justify-content-md-start justify-content-center mb-4 mt-md-3 mt-0">
					<div class="col-sm-12 col-lg-4 col-md-4 input-wrapper m-datepicker">
						<app-date-picker formControlName="startOfWorkDateAsEmployee" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION14.QUESTION1'|translate}}" #startOfWorkDateAsEmployee (onUpdate)="onDateUpdate($event, 'BORROWERS_DETAILS.QUESTION14.PH1')"></app-date-picker>
						<label class="app-error d-flex justify-content-center justify-content-md-end mr-md-2 mr-0" *ngIf="borrowerDetails.get('startOfWorkDateAsEmployee').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-flex justify-content-center justify-content-md-end mr-md-2 mr-0" *ngIf="borrowerDetails.get('startOfWorkDateAsEmployee').hasError('invalidDate') && !borrowerDetails.get('startOfWorkDateAsEmployee').hasError('required') && submitted" role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
					</div>
					<div class="col-sm-12 col-lg-4 col-md-4 justify-content-center mt-4 mt-md-0"> 
						<div class="">
							<app-animated-input formControlName="monthlyIncomeAsEmployee" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION14.PH1'|translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION14.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('monthlyIncomeAsEmployee').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>
					</div>
				</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='14', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>


			<!-- question 16 -->
			<question [qID]="'16'">
				<div class="mx-4 mt-md-0 mt-5">
				<div class="text-md-right text-center mb-3">
					<h1 class="app-title-xxxlarge-blue">
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION1"|translate}}</div>
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION2"|translate}}</div>
						<div>{{"BORROWERS_DETAILS.QUESTION11.QUESTION3"|translate}}</div>
					</h1>
				</div>
		
				<div class="row d-flex justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center">
					 <div class="col-12 col-lg-3 mt-2 mt-md-0">
						<app-animated-input formControlName="companyNameForEmployee" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION11.PH1' | translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION11.PH1'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="true" [hasTitle]="false" tabindex="0"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('companyNameForEmployee').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('employersCompanyName').hasError('pattern') && submitted" role="alert">{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
						
				     </div>
						<!--Company Classification-->
						<div class="col-12 col-lg-3 mt-md-n4 mt-0">
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH3"|translate}}</label>

							<app-dplist-new [valueArr]='companyClassificationList' formControlName="companyClassificationForEmployee" tabindex="0"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('companyClassificationForEmployee').hasError('required') && submitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>							
						</div>
				

						<div class="col-12 col-lg-3 mt-md-n4 mt-0">
							<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH4"|translate}}</label>
							<div class="input-wrapper">
								<app-mat-autocomplete [data]="cities" formControlName="yeshuvAvodaForEmployee" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}" [attAriaLabel]="'PROPERTY_DETAILS.Q1.PH1'|translate"></app-mat-autocomplete>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('yeshuvAvodaForEmployee').hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('yeshuvAvodaForEmployee').hasError('isNotInList') && !borrowerDetails.get('yeshuvAvodaForEmployee').hasError('required') && submitted">
									{{'PROPERTY_DETAILS.Q1.NOT_IN_LIST_ERROR' | translate}}
								</label> 
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid, 'button-primary-disabled': !(borrowerDetails.valid && qID=='16')}">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
					</div>
			</question>

			<!-- question 18 -->
			<question [qID]="'18'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION18.QUESTION"|translate}}</h1>
					
					<div class="row justify-content-md-start justify-content-center mb-4 mt-md-4 mt-0">
						<div class="col-sm-12 col-lg-4 col-md-4 m-datepicker">
							<app-date-picker formControlName="startOfWorkDateAsEmployee1" [minDate]="minWorkDate" [maxDate]="maxWorkDate" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION18.QUESTION'|translate}}" attrDateID="'d18'"></app-date-picker>
							<label class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('startOfWorkDateAsEmployee1').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('startOfWorkDateAsEmployee1').hasError('invalidDate') && !borrowerDetails.get('startOfWorkDateAsEmployee1').hasError('required') && submitted" role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
						</div>
						<div class="col-sm-12 col-lg-4 col-md-4 justify-content-center"> 
							<div class="">
								<app-animated-input formControlName="annualIncome-b" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION18.PH2'|translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION18.PH2'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('annualIncome-b').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='18', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<!-- question 20 -->
			<question [qID]="'20'">
				<div class="mx-4 mt-md-0 mt-5 ">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION20.QUESTION"|translate}}</h1>
					<div>{{"BORROWERS_DETAILS.QUESTION20.QUESTION2"|translate}}</div>
					<div class="d-flex flex-column justify-content-lg-start  justify-content-sm-center text-right">
					<app-incomes-array  formArrayName="otherIncome" (onAddFormGroup)="setValidators()" [needSources]="true" (onIncomesChange)="setValidators()" [incomeTypes]="typeCmbo" [incomesFormArray]="borrowerDetails.get('otherIncome')"
					 [displayErrors]="submitted" [titles]="['BORROWERS_DETAILS.QUESTION20.LABEL1', 'BORROWERS_DETAILS.QUESTION20.LABEL2', 'BORROWERS_DETAILS.QUESTION20.LABEL3']" [ph]="['BORROWERS_DETAILS.QUESTION20.LABEL1_PH' | translate]"
					 [buttons]="['BORROWERS_DETAILS.QUESTION20.BUTTON_ADD','BORROWERS_DETAILS.QUESTION20.BUTTON_ADD_AND_SAVE']" [addButtonOff]="true">
					</app-incomes-array>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='20', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
	
					</div>
				</div>
			</question>

			<!-- question 20.1 -->
			<question [qID]="'20.1'">
				<div class="mx-4 mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION20-5.QUESTION_A"|translate}}</h1>

	
					<div class="btn-group-toggle " data-toggle="buttons">
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('seniority').value==='under'}" tabindex="0" data-id="qID8aa" data-fieldName="seniority" data-fieldValue="under">
							{{"BORROWERS_DETAILS.QUESTION8.OP1"|translate}}
							<input class="radio" type="radio" formControlName="seniority" value="under" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-a').value==='middle'}" tabindex="0" data-id="qID8ab" data-fieldName="seniority" data-fieldValue="middle">
							{{"BORROWERS_DETAILS.QUESTION8.OP2"|translate}}
							<input class="radio" type="radio" formControlName="seniority" value="middle" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
						<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('startOfWorkDateWithEmployer-a').value==='over'}" tabindex="0" data-id="qID8ac" data-fieldName="seniority" data-fieldValue="over">
							{{"BORROWERS_DETAILS.QUESTION8.OP3"|translate}}
							<input class="radio" type="radio" formControlName="seniority" value="over" (change)="onSubmit(borrowerDetails)" click2change tabindex="-1">
						</label>
					</div>
					</div>
			</question>

			<!-- question 29 -->
			<question [qID]="'29'" >
				<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION29.QUESTION"|translate}}</h1>

				<app-borrowers-array [status]="status" formArrayName="borrowersAdvancedArray" (onAddFormGroup)="setValidators()" [childrenNumber]="childrenNumber"
				 [maritalStatus]="maritalStatus" [qID]="29" [borrowersArray]="borrowerDetails.get('borrowersAdvancedArray')" [displayErrors]="submitted">
				</app-borrowers-array>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='29', 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>

				</div>
			</question>


			<ng-container *ngFor="let borrower of borrowers; let i = index" ngProjectAs="question">

				<!-- question 33      as5-->
				<question [qID]="getqID(33, i)">
					<div class="mx-4 mt-md-0 mt-5 ">

						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION33.QUESTION"| translate: {name: borrowers[i].fields[0].answerValue || ''} }}</h1>
							<div class="row justify-content-md-start justify-content-center mb-4 mt-md-n4 mt-0">

								<div class="col-12 col-lg-4 mt-3">
									<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"COMMON.SELECT_EDUCATION_PH"|translate}}</label>
		
									<app-dplist-new [valueArr]='educationCombo' formControlName="brwEducation-{{i+1}}" tabindex="0" [atrrAriaLabel]="'COMMON.SELECT_EDUCATION_PH'|translate"></app-dplist-new>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwEducation-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>

								</div>
								<div class="col-12 col-lg-4 mt-3">
									<label class="text-title app-font-size-xxs app-font-regular text-right pr-2">{{"BORROWERS_DETAILS.QUESTION33.PH1"|translate}}</label>

									<app-mat-autocomplete [data]="professionsList" formControlName="brwProfession-{{i+1}}" placeholder="{{'BORROWERS_DETAILS.QUESTION33.PH1'|translate}}" tabindex="0"></app-mat-autocomplete>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwProfession-'+ (i+1)).hasError('required') && submitted">
										{{ 'COMMON.FIELD_REQUIRED' | translate }}
									</label>
								</div>

							</div>
							<div class="d-flex justify-content-md-end justify-content-center mt-5">
								<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='33-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
			
							</div>
					</div>

				</question>

				<!-- question 35-1 as7   display borrower's name! -->

				<question [qID]="getqID(35, i)">
					<div class="mx-4 mt-md-0 mt-5 ">
					<h1>{{'BORROWERS_DETAILS.QUESTION35.QUESTION'|translate: {name: borrowers[i].fields[0].answerValue || ''} }}</h1>
					<div class="d-flex  justify-content-md-start justify-content-center text-center">
						<box-selector formControlName="brwEmploymentStatus-{{i+1}}" [options]="options" (optionClicked)="onSubmit(borrowerDetails)"></box-selector>
					</div>
					
					</div>
				</question>

				<question [qID]="getqID('35.1', i)">
					<label class="max-width-page" tabindex="0" data-id="qID35.1">
						<div class="text-lg-right text-md-center text-center">
							<h1 class="app-title-xxxlarge-blue">{{'BORROWERS_DETAILS.QUESTION35-1.QUESTION'|translate}}</h1>
						</div>
					</label>
			
					<div class="d-flex flex-column justify-content-md-start justify-content-center">
						<app-mat-autocomplete [data]="cities" formControlName="brwYeshuvAvodaForIndependent-{{i+1}}" placeholder="{{'BORROWERS_DETAILS.QUESTION35-1.PH1'|translate}}" [attAriaLabel]="'BORROWERS_DETAILS.QUESTION35-1.PH1'|translate"></app-mat-autocomplete>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvodaForIndependent-'+(i+1)).hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvodaForIndependent-'+(i+1)).hasError('isNotInList') && !borrowerDetails.get('brwYeshuvAvodaForIndependent-'+(i+1)).hasError('required') && submitted">
							{{'BORROWERS_DETAILS.QUESTION7-1.NOT_IN_LIST_ERROR' | translate}}
						</label> 
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5 mt-md-0">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='35.1-'+(i+1), 'button-primary-disabled': !(borrowerDetails.valid && qID=='35.1-'+(i+1))}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</question>

				<!-- question 36a-1 as8-->
				<question [qID]="getqID('36a', i)">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION36.QUESTION_A" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
	
		
						<div class="btn-group-toggle " data-toggle="buttons">
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-a-'+(i+1)).value==='under1'}" tabindex="0" data-id="qID{{getqID('36a', i)}}a" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-a-'+(i+1)" data-fieldValue="under1">
								{{"BORROWERS_DETAILS.QUESTION8.OP1"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-a-{{i+1}}" value="under1" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-a-'+(i+1)).value==='over1'}" tabindex="0" data-id="qID{{getqID('36a', i)}}b" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-a-'+(i+1)" data-fieldValue="over1">
								{{"BORROWERS_DETAILS.QUESTION8.OP2"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-a-{{i+1}}" value="over1" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-a-'+(i+1)).value==='over3'}" tabindex="0" data-id="qID{{getqID('36a', i)}}c" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-a-'+(i+1)" data-fieldValue="over3">
								{{"BORROWERS_DETAILS.QUESTION8.OP3"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-a-{{i+1}}" value="over3" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
						</div>
						</div>
				</question>

				<!-- question 36b-1 as8-->
				<question [qID]="getqID('36b', i)">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION36.QUESTION_A" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
	
		
						<div class="btn-group-toggle " data-toggle="buttons">
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-b-'+(i+1)).value==='under1'}" tabindex="0" data-id="qID{{getqID('36b', i)}}a" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-b-'+(i+1)" data-fieldValue="under1">
								{{"BORROWERS_DETAILS.QUESTION8.OP1"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-b-{{i+1}}" value="under1" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-b-'+(i+1)).value==='over1'}" tabindex="0" data-id="qID{{getqID('36b', i)}}b" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-b-'+(i+1)" data-fieldValue="over1">
								{{"BORROWERS_DETAILS.QUESTION8.OP2"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-b-{{i+1}}" value="over1" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
							<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':borrowerDetails.get('brwStartOfWorkDateWithEmployer-b-'+(i+1)).value==='over3'}" tabindex="0" data-id="qID{{getqID('36b', i)}}c" [attr.data-fieldName]="'brwStartOfWorkDateWithEmployer-b-'+(i+1)" data-fieldValue="over3">
								{{"BORROWERS_DETAILS.QUESTION8.OP3"|translate}}
								<input class="radio" type="radio" formControlName="brwStartOfWorkDateWithEmployer-b-{{i+1}}" value="over3" (change)="onSubmit(borrowerDetails)" tabindex="-1">
							</label>
						</div>
					</div>
				</question>

				<!-- question 37a-1     as9-->
				<question [qID]="getqID('37a', i)">
					<div class="mx-4 mt-md-0 mt-5">

						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION37.QUESTION" | translate : {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
						<div class="row ">
							<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
							<div class="">
								<app-animated-input formControlName="brwHowLongWorkedPreviousWorkplace-a-{{i+1}}" [minValue]="0" [type]="'number'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION37.QUESTION'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="false" tabindex="0"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-a-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-a-'+ (i+1)).hasError('negativeNumber') && !borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-a-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.NEGATIVE_NUMBER' | translate }}</label>
							</div>
						</div>
						</div>
		
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='37a-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>
				</question>

				<!-- question 37a-1     as9-->
				<question [qID]="getqID('37b', i)">
					<div class="mx-4 mt-md-0 mt-5">

						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION37.QUESTION" | translate : {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
						<div class="row ">
							<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
							<div class="">
								<app-animated-input formControlName="brwHowLongWorkedPreviousWorkplace-b-{{i+1}}" [minValue]="0" [type]="'number'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION37.QUESTION'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="false" tabindex="0"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-b-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-b-'+ (i+1)).hasError('negativeNumber') && !borrowerDetails.get('brwHowLongWorkedPreviousWorkplace-b-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.NEGATIVE_NUMBER' | translate }}</label>
							</div>
						</div>
						</div>
		
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='37b-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>
				</question>

				<!-- question 38     as10-->
				<question [qID]="getqID(38, i)">
					<div class="mx-4 mt-md-0 mt-5">

						<h1 class="app-title-xxxlarge-blue">{{"BORROWERS_DETAILS.QUESTION38.QUESTION" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
						<div class="row ">
							<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
							<div class="">
								<app-animated-input formControlName="brwMonthlyIncome-{{i+1}}" [type]="'text'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION38.QUESTION'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" tabindex="0"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwMonthlyIncome-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwMonthlyIncome-'+ (i+1)).hasError('min') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>

							</div>
						</div>
						</div>
		
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='38-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>

				</question>

				<!-- question 39    as11-->
				<question [qID]="getqID(39, i)">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION1" | translate: {name: borrowers[i].fields[0].answerValue || ''} }}</div>
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION2" |translate}}</div>
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION3" |translate}}</div>
						</h1>
	
						<div class="row form-row justify-content-md-start justify-content-center">

							<div class="form-group col-12 col-md-4 input-wrapper mt-3">
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION39.PH1"|translate}}</label>
								<app-animated-input formControlName="brwEmployersCompanyName-{{i+1}}" [type]="'text'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION39.PH1'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="true" tabindex="0"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwEmployersCompanyName-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwEmployersCompanyName-'+ (i+1)).hasError('pattern') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							</div>
							<div class="form-group col-12 col-md-4 input-wrapper pr-0 w-100 mt-3">  
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION39.COMPANY_CLASSIFICATION_PH"|translate}}</label>
		
								<app-dplist-new [valueArr]='companyClassificationList' formControlName="brwEmployersCompanyClassification-{{i+1}}" [disabled]="borrowerDetails.get('brwEmployersCompanyClassification-'+ (i+1)).disabled" [asyncData]="false" tabindex="0"></app-dplist-new>
								<label class="m-error" *ngIf="borrowerDetails.get('brwEmployersCompanyClassification-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							</div>

							<div class="form-group col-12 col-md-4 input-wrapper pr-0 w-100 mt-3">
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH4"|translate}}</label>
								<div class="input-wrapper">
									<app-mat-autocomplete [data]="cities" formControlName="brwYeshuvAvoda-{{i+1}}" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}" [attAriaLabel]="'PROPERTY_DETAILS.Q1.PH1'|translate"></app-mat-autocomplete>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvoda-'+ (i+1)).hasError('required') && submitted">
										{{ 'COMMON.FIELD_REQUIRED' | translate }}
									</label>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvoda-'+ (i+1)).hasError('isNotInList') && !borrowerDetails.get('brwYeshuvAvoda-'+ (i+1)).hasError('required') && submitted">
										{{'PROPERTY_DETAILS.Q1.NOT_IN_LIST_ERROR' | translate}}
									</label>
								</div> 
							</div>
							
						</div>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='39-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>
				</question>

				<!-- question 41 as13-->
				<question [qID]="getqID(41, i)">

					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION41.QUESTION" | translate: {name: borrowers[i].fields[0].answerValue || ''} }}</h1>
	
					<div class="row  form-row justify-content-md-start justify-content-center">

						<div class="form-group col-12 col-md-4 mt-3">
							<app-animated-input formControlName="brwAnnualIncome-a-{{i+1}}" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION41.PH1'|translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION41.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwAnnualIncome-a-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwAnnualIncome-a-'+ (i+1)).hasError('min') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								
						</div>
						</div>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='41-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>

				</question>

				<!-- question 42-1  as14-->
				<question [qID]="getqID(42, i)">

					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION42.QUESTION" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
	
					<div class="row  form-row justify-content-md-start justify-content-center">
						<div class="form-group col-12 col-md-4 input-wrapper mt-3">
							<app-date-picker formControlName="brwStartOfWorkDateAsEmployee-{{i+1}}" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION42.QUESTION'|translate}}" tabindex="0"></app-date-picker>
							<label class="app-error d-flex justify-content-center justify-content-md-start mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwStartOfWorkDateAsEmployee-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-flex justify-content-center justify-content-md-start mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwStartOfWorkDateAsEmployee-'+ (i+1)).hasError('invalidDate') && !borrowerDetails.get('brwStartOfWorkDateAsEmployee-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
						</div>
						<div class="form-group col-12 col-md-4 input-wrapper mt-3">
							<app-animated-input formControlName="brwMonthlyIncomeAsEmployee-{{i+1}}" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION42.PH1'|translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION39.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwMonthlyIncomeAsEmployee-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwMonthlyIncomeAsEmployee-'+ (i+1)).hasError('min') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						</div>

						</div>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='42-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>

						</div>
				</question>

				<!-- question 44    as16-->
				<question [qID]="getqID(44, i)">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION1" | translate: {name: borrowers[i].fields[0].answerValue || ''} }}</div>
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION2" |translate}}</div>
							<div>{{"BORROWERS_DETAILS.QUESTION39.QUESTION3" |translate}}</div>
						</h1>
	
						<div class="row form-row justify-content-md-start justify-content-center">

							<div class="form-group col-12 col-md-4 input-wrapper mt-3">
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION39.PH1"|translate}}</label>
								<app-animated-input formControlName="brwCompanyNameForEmployee-{{i+1}}" [type]="'text'" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION39.PH1'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="true" tabindex="0"></app-animated-input>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwCompanyNameForEmployee-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
								<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwCompanyNameForEmployee-'+ (i+1)).hasError('pattern') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							</div>
							<div class="form-group col-12 col-md-4 input-wrapper pr-0 w-100 mt-3">  
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION39.COMPANY_CLASSIFICATION_PH"|translate}}</label>
		
								<app-dplist-new [valueArr]='companyClassificationList' formControlName="brwCompanyClassificationForEmployee-{{i+1}}" [disabled]="borrowerDetails.get('brwCompanyClassificationForEmployee-'+ (i+1)).disabled" [asyncData]="false" tabindex="0"></app-dplist-new>
								<label class="m-error" *ngIf="borrowerDetails.get('brwCompanyClassificationForEmployee-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							</div>

							<div class="form-group col-12 col-md-4 input-wrapper pr-0 w-100 mt-3">
								<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"BORROWERS_DETAILS.QUESTION11.PH4"|translate}}</label>
								<div class="input-wrapper">
									<app-mat-autocomplete [data]="cities" formControlName="brwYeshuvAvodaForEmployee-{{i+1}}" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}" [attAriaLabel]="'PROPERTY_DETAILS.Q1.PH1'|translate"></app-mat-autocomplete>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('required') && submitted">
										{{ 'COMMON.FIELD_REQUIRED' | translate }}
									</label>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('isNotInList') && !borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('required') && submitted">
										{{'PROPERTY_DETAILS.Q1.NOT_IN_LIST_ERROR' | translate}}
									</label>
								</div> 
							</div>
							
						</div>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='44-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>
					</div>
				</question>

				<!-- question 46     as18-->
				<question [qID]="getqID(46, i)">

					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION46.QUESTION" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
	
					<div class="row  form-row justify-content-md-start justify-content-center">
						<div class="form-group col-12 col-md-4 mt-3">
							<app-date-picker formControlName="brwStartOfWorkDateAsEmployee1-{{i+1}}" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION42.QUESTION'|translate}}" tabindex="0"></app-date-picker>
							<label class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwStartOfWorkDateAsEmployee1-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwStartOfWorkDateAsEmployee1-'+ (i+1)).hasError('invalidDate') && !borrowerDetails.get('brwStartOfWorkDateAsEmployee1-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
						</div>
						<div class="form-group col-12 col-md-4 mt-3">
							<app-animated-input formControlName="brwAnnualIncome-b-{{i+1}}" [type]="'text'" placeholder="{{'BORROWERS_DETAILS.QUESTION46.PH2'|translate}}" attAriaLabel="{{'BORROWERS_DETAILS.QUESTION39.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" tabindex="0"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwAnnualIncome-b-'+ (i+1)).hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="borrowerDetails.get('brwAnnualIncome-b-'+ (i+1)).hasError('min') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
	
						</div>

						</div>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='46-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.PROCEED"|translate}}</button>
		
						</div>

					</div>
				</question>

				<!-- question 48-1      as20-->
				<question [qID]="getqID(48, i)">
					<div class="mx-4 mt-md-0 mt-5">
						<h1 class="app-title-xxxlarge-blue text-lg-right">{{"BORROWERS_DETAILS.QUESTION48.QUESTION" | translate: {name:borrowers[i].fields[0].answerValue || ''} }}</h1>
				
						<app-incomes-array formArrayName="brwOtherIncome-{{i+1}}" (onAddFormGroup)="setValidators()" [needSources]="true" (onIncomesChange)="setValidators()" [incomeTypes]="typeCmbo" [incomesFormArray]="borrowerDetails.get('brwOtherIncome-'+ (i+1))"
						 [displayErrors]="submitted" [titles]="['BORROWERS_DETAILS.QUESTION20.LABEL1', 'BORROWERS_DETAILS.QUESTION20.LABEL2', 'BORROWERS_DETAILS.QUESTION20.LABEL3']" [ph]="['BORROWERS_DETAILS.QUESTION20.LABEL1_PH' | translate]"
						 [buttons]="['BORROWERS_DETAILS.QUESTION20.BUTTON_ADD','BORROWERS_DETAILS.QUESTION20.BUTTON_ADD_AND_SAVE']" [addButtonOff]="true">
						</app-incomes-array>
						<div class="d-flex justify-content-md-end justify-content-center mt-5">
							<button type="submit" class="app-button" [ngClass]="{'button-primary': borrowerDetails.valid && qID=='48-'+(i+1), 'button-primary-disabled': !borrowerDetails.valid}">{{"COMMON.BUTTON_SAVE"|translate}}</button>
		
						</div>
					</div>
				</question>
			</ng-container>
		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/borrowers-details/borrowers-details.component.html